import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

/* import from view folder */
import Search from "../../../views/search";
import TableCombination from "../../../views/combination/table";

/* import element from component folder */
import TableList from "../../../components/tableList";

/* import config from json folder */
import searchItems from "../../../assecs/json/search/events/point.json";
import tableHeader from "../../../assecs/json/table/events/point.json";

/* import custom hook function */
import useSearch from '../../../hook/useSearch';

/* import function from store folder */
import { setModel } from '../../../store/components/modelSlice';
import { resetModel } from '../../../store/components/modelSlice';

/* import context function */
import { PaginationProvider } from '../../../context/pageContext';

/* import fetch function */
import { FetchPointMemberSource } from "../../../services/events";

const PointEvent = () => {
    const dispatch = useDispatch();
    const [condition, setCondition, setPagination] = useSearch();
    const [source, setSource] = useState({});
    const [tableBody, setTable] = useState(null);
    const [tablePages, setPages] = useState(null);
    const { data } = useSelector(state => state.model);
    
    const cancelHandler = () => dispatch(resetModel());
    const changHandler = ({target: { name, value, content }}) => {

        source[name] = value;
        source.content = content
        
        setSource(source);
    };

    const tableLists = ({ data, totalCount }) => {
        const lists = [];
        
        data.map((value, index) => 
            lists.push(<TableList key={ value.mId } index={ index } targets={ tableHeader.member } content={ value } id={ value.mId } />)
        );
        
        setTable(lists);
        setPages(totalCount);
    };

    const modelHandler = modelType => {
        const _source = Object.assign({}, source);

        _source.epId = data.epId;
        _source.reward = data.reward;
        _source.eventName = data.eventName;

        dispatch(setModel({type: modelType, data: _source}));
    };

    useEffect(() => {
        FetchPointMemberSource(condition)
        .then(response => tableLists(response))
        .catch(error => console.log(error));
    }, [ condition ]);

    return (
        <Modal show={ true } centered size='lg'>
            <Modal.Header>Give Members Points</Modal.Header>
            <Modal.Body>
                <PaginationProvider pagination={{ condition, setPagination }}>
                    <div className="modal-form-container">
                        <div className="form-item">
                            <div className='label'>Event Name</div>
                            <span className='semicolon'>：</span>
                            <span className='text'>{ data.eventName }</span>
                        </div>
                        <div className="form-item">
                            <div className='label'>Points</div>
                            <span className='semicolon'>：</span>
                            <span className='text'>{ data.reward }</span>
                        </div>
                        <div className="form-table-item">
                            <Search resource={ searchItems.member } onSubmit={ setCondition } />
                            <TableCombination header={ tableHeader.member } body={ tableBody } totalCount={ tablePages } presetSelect={ data.mIds } presetContent={ data.content } selectHandler={ changHandler }/>
                        </div>
                        <div className="button-container">
                            <Button type="button" data-shadow onClick={ cancelHandler }>Cancel</Button>                        
                            <Button type="button" data-shadow onClick={ () => modelHandler('point-checked') }>Next</Button>
                        </div>
                    </div>
                </PaginationProvider>
            </Modal.Body>
        </Modal>
    )
}

export default PointEvent;